/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

export default {
  themeDayKey() {
      const d = new Date();
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    },

  themeOfDay() {
      // Themanummer = dag van de maand: op de 7e hoort thema 7.
      const day = new Date().getDate();
      const own = (this.state.themeWords || {})[day];
      return own || this.dayThemes[(day - 1) % this.dayThemes.length];
    },

  // Een oude krabbel toont zijn eigen thema: dag van de maand -> themanummer,
  // uit het rijtje dat op die dag gold.
  themeForDate(created) {
      const d = created ? new Date(String(created).replace(' ', 'T')) : null;
      if (!d || isNaN(d.getTime())) return '';
      const day = d.getDate();
      const own = (this.state.themeWords || {})[day];
      if (own) return own;
      const key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
      const list = key < this.themeSwitchDay ? this.oldThemes : this.dayThemes;
      return list[(day - 1) % list.length];
    }
};
